import { useIsAuthenticated } from '@azure/msal-react'
import { useAuth } from '@/hooks/useAuth'
import { Navigate } from 'react-router-dom'

interface AuthGuardProps {
  children: React.ReactNode
  minRole?: string
}

export default function AuthGuard({ children, minRole }: AuthGuardProps) {
  const isAuthenticated = useIsAuthenticated()
  const { hasMinRole, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />
  }

  if (minRole && !hasMinRole(minRole)) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900">Access Denied</h1>
          <p className="mt-2 text-gray-600">You do not have permission to access this page.</p>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
